import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgSocialIconsPrint = function SvgSocialIconsPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#929292",
    fillRule: "evenodd",
    d: "M11.995 0C5.046 0-.53 5.922.04 12.99a11.97 11.97 0 0 0 11.053 10.977C18.13 24.482 24 18.924 24 11.996 24 5.368 18.625 0 11.995 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.43 8.846V6.3H8.566v2.546H7.409V5.143h9.178v3.703zm1.562 2.989q.231 0 .405-.174a.56.56 0 0 0 .173-.405.56.56 0 0 0-.173-.405.555.555 0 0 0-.81 0 .56.56 0 0 0-.174.405q0 .232.174.405.173.174.405.174m-1.562 6.036V14.17H8.566v3.702zm1.157 1.158H7.409v-3.395H4.286V10.89q0-.869.59-1.458.59-.588 1.457-.586H17.67q.869 0 1.458.586c.393.393.586.875.586 1.458v4.744h-3.123v3.395zm1.967-4.552v-3.59a.85.85 0 0 0-.255-.633.87.87 0 0 0-.632-.251H6.329a.86.86 0 0 0-.632.254.86.86 0 0 0-.255.633v3.587H7.41v-1.466h9.178v1.466z"
  })));
};

export { SvgSocialIconsPrint as ReactComponent };
//# sourceMappingURL=social-icons-print.svg.esm.js.map
